// eslint-disable-next-line import/prefer-default-export
export const EVENT_TRACKING = 'EVENT_TRACKING';
